import { SessionStorage } from '../burger-king-lib/utils/storage.web';
import { LocalSessionKey } from '../burger-king-lib/constants/app-constants';

export function getSearchResultPayload(search_string, theme) {
  return {
    category_id: '',
    outlet_id:
      SessionStorage.get(LocalSessionKey.OUTLET_ID) &&
      SessionStorage.get(LocalSessionKey.OUTLET_ID).toString(),
    search_string,
    filter_options: [],
    order_type: theme
  };
}

export function getSearchSuggestionsPayload(data, isGet, isClear) {
  return {
    name: (data && data.name) || '',
    is_clear: isClear || false,
    is_get: isGet || false
  };
}

export function getProductListingPayload(
  id,
  filterOptions,
  theme,
  tags,
  food_type
) {
  return {
    category_id: id,
    outlet_id:
      SessionStorage.get(LocalSessionKey.OUTLET_ID) &&
      SessionStorage.get(LocalSessionKey.OUTLET_ID).toString(),
    filter_options: filterOptions || [],
    search_string: '',
    order_type: theme,
    tag_ids: tags || [],
    food_type: food_type || ''
  };
}

export function getProductAddonPayload(theme, entity_id) {
  return {
    outlet_id:
      SessionStorage.get(LocalSessionKey.OUTLET_ID) &&
      SessionStorage.get(LocalSessionKey.OUTLET_ID).toString(),
    order_type: theme,
    entity_id
  };
}

export function getProductCategoryPayload(entity_id) {
  return {
    outlet_id:
      SessionStorage.get(LocalSessionKey.OUTLET_ID) &&
      SessionStorage.get(LocalSessionKey.OUTLET_ID).toString(),
    entity_id
  };
}

export function getAllAddonsPayload() {
  return {
    outlet_id:
      SessionStorage.get(LocalSessionKey.OUTLET_ID) &&
      SessionStorage.get(LocalSessionKey.OUTLET_ID).toString()
  };
}
